const initialState = {
  total: 0,
};
const TotalFixedCostReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TOTAL_FIXED_COST":
      return (initialState.total = action.payload);
    default:
      return state;
  }
};

export default TotalFixedCostReducer;
